import { render, staticRenderFns } from "./updatepincodeagainshipmentid.vue?vue&type=template&id=1ca04165&"
import script from "./updatepincodeagainshipmentid.vue?vue&type=script&lang=js&"
export * from "./updatepincodeagainshipmentid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports